import getStaticData from '../helpers/getStaticData'
const sitecoreData = getStaticData('sitecore')

export default {
  rootPath: '/',
  flightOffers: '/flight-offers',
  basename: sitecoreData.basePath,
}
